import React from "react";
import styled from "styled-components";
import tw from "twin.macro";

import Header from "../headers/light.js";

import { ReactComponent as SvgDecoratorBlob1 } from "../../images/svg-decorator-blob-1.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "../../images/dot-pattern.svg";
import { IoIosCall } from "react-icons/io";
import ClockKeyImage from "images/keyservice/erasmusbrug.avif";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col lg:flex-row md:items-center max-w-screen-xl mx-auto py-2 sm:py-24`;
const LeftColumn = tw.div`relative lg:w-6/12 lg:pr-12 flex-shrink-0 text-center lg:text-left`;
const RightColumn = tw.div`relative mt-12 lg:mt-0 flex flex-col justify-center`;

const Heading = tw.h1`font-black text-3xl md:text-5xl leading-snug max-w-3xl text-[#3F62A3]`;
const Paragraph = tw.p`my-5 lg:my-8 text-sm lg:text-base font-medium text-black max-w-lg mx-auto lg:mx-0`;

const PrimaryButton = tw.button`font-bold px-8 lg:px-10 py-3 rounded-full bg-white hover:bg-blue-800 hover:text-white focus:bg-blue-800 border border-blue-800 text-blue-800 focus:shadow-outline focus:outline-none transition duration-300`;
const PrimaryButton1 = tw.button`font-bold px-8 lg:px-10 py-3 rounded-full bg-blue-900 hover:bg-blue-800 focus:bg-blue-800 border border-blue-800 text-white focus:shadow-outline focus:outline-none transition duration-300`;

const IllustrationContainer = tw.div`flex justify-center md:justify-end items-center relative max-w-3xl lg:max-w-none`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none opacity-10 absolute left-0 bottom-0 h-64 w-64 transform -translate-x-2/3  -z-10 fill-current text-blue-300`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none fill-current text-blue-500 opacity-25 absolute w-32 h-32 right-0 bottom-0 transform translate-x-10 translate-y-10 -z-10`}
`;

const SlantedBackground = styled.span`
  ${tw`relative text-white px-4 -mx-4 py-2`}
  &::before {
    content: "";  
    ${tw`absolute inset-0 bg-blue-900 transform -skew-x-12 -z-10`}
  }
`;

styled("select");

export default ({
  description = "Onze gecertificeerde slotenmakers staan dag en nacht voor je klaar. Deskundig advies, snelle hulp en duurzame oplossingen voor elk type slot.",
  imageDecoratorBlob = true,
}) => {
  return (
    <div>
      <Header />
      <Container>
        <TwoColumn>
          <LeftColumn>
            <Heading>
              <span>Betrouwbare hulp bij</span>
              <br />
              <SlantedBackground>SAFETY LOCKS</SlantedBackground>
            </Heading>
            <Paragraph>{description}</Paragraph>
            <div className={"flex gap-1 lg:justify-start justify-center"}>
              <a href="tel:nvt" className={"text-sm md:justify-start"}>
                <PrimaryButton className={"flex"}>
                  <IoIosCall className={"mt-1"} />
                  <span className={"sm:ml-1 ml-0"}>nvt</span>
                </PrimaryButton>
              </a>
              <a href="/offerte-aanvragen" className={"text-sm lg:hidden flex"}>
                <PrimaryButton1 className={""}>
                  Offerte aanvragen
                </PrimaryButton1>
              </a>
              <a
                href="/brochure.pdf"
                rel="noopener noreferrer"
                target="_blank"
                className={"text-sm flex"}
              >
                <PrimaryButton1 className={"flex"}>
                  Download brochure
                </PrimaryButton1>
              </a>
            </div>
          </LeftColumn>
          <RightColumn>
            <IllustrationContainer>
              <img
                src={ClockKeyImage}
                alt="Hero"
                className={"rounded-3xl shadow-lg"}
              />
              {imageDecoratorBlob && <DecoratorBlob2 />}
            </IllustrationContainer>
          </RightColumn>
        </TwoColumn>
        <DecoratorBlob1 />
      </Container>
    </div>
  );
};
